import React from "react";
import { default as MUIInputAdornment } from "@mui/material/InputAdornment";
import styled from "styled-components";

const StyledMUIInputAdornment = styled(MUIInputAdornment)``;

export const InputAdornment = (props) => {
  return <StyledMUIInputAdornment {...props} />;
};
